const reasons = [
  {
    icon: "ri-shield-star-fill",
    title: "Fully Insured & Professional",
    desc: "Mighty Cleaning Services Ltd is fully insured, giving you complete peace of mind on every job. Our uniformed, trained team always arrives on time and works to the highest professional standards across Northfleet and Gravesend.",
  },
  {
    icon: "ri-star-fill",
    title: "4.9★ Google Rated",
    desc: "Our customers love us. With a 4.9-star Google rating and 4.8-star Facebook rating, our reputation is built on consistent quality, honest pricing, and excellent customer service — not just in Northfleet but across the wider Kent area.",
  },
  {
    icon: "ri-tools-fill",
    title: "Latest Gutter Clearing Technology",
    desc: "We use high-powered SkyVac and wet & dry vacuum systems that clear gutters from ground level in many cases — meaning no unnecessary ladders, faster service, and safer working conditions. Your gutters are left completely clear.",
  },
  {
    icon: "ri-map-pin-2-fill",
    title: "Local Expertise in Northfleet & Gravesend",
    desc: "As a local business based in Northfleet, Kent, we understand the properties and conditions in this area. From Victorian terraces in Gravesend to modern estates in Northfleet — we know exactly what's needed.",
  },
  {
    icon: "ri-price-tag-3-fill",
    title: "Transparent, No-Surprise Pricing",
    desc: "No hidden charges, no surprises. We provide clear, upfront quotes for all gutter clearance and window cleaning services. Our competitive rates mean you get exceptional quality without paying over the odds — for both one-off and regular maintenance visits.",
  },
];

export default function ServicesWhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: Image + Stats */}
          <div>
            <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
              <img
                src="https://storage.readdy-site.link/project_files/a5b4d2b9-0314-4e93-a996-08841a88cd10/a8ac21a9-4a36-40e7-8341-937da92dfbcb_edited_4432c7ad4ef3990be85386fd35d2bd4a_511b424f.jpg?v=4bbf60bfa5ce0ba389638d61cf622572"
                alt="Mighty Cleaning Services Ltd fleet of vans in Northfleet"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Trust badges */}
            <div className="grid grid-cols-3 gap-4">
              {[
                { value: "4.9★", label: "Google Rating" },
                { value: "4.8★", label: "Facebook Rating" },
                { value: "500+", label: "Properties Served" },
              ].map((badge) => (
                <div key={badge.label} className="text-center bg-[#F8FAFE] rounded-xl py-5 px-3 border border-gray-100">
                  <p className="font-heading text-[#1E88E5] text-xl mb-1" style={{ fontWeight: 800 }}>
                    {badge.value}
                  </p>
                  <p className="font-body text-gray-500 text-xs">{badge.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Reasons */}
          <div>
            <span className="text-[#1E88E5] font-heading font-semibold text-sm uppercase tracking-widest block mb-3">
              Why Choose Us
            </span>
            <h2
              className="font-heading text-[#0F2040] leading-tight mb-4"
              style={{ fontSize: "clamp(1.8rem, 3vw, 2.4rem)", fontWeight: 800 }}
            >
              Why Northfleet &amp; Gravesend Trust Mighty Cleaning Services
            </h2>
            <p className="text-gray-600 font-body text-base leading-relaxed mb-10">
              From professional window cleaning to expert gutter clearance, here's what makes Mighty Cleaning Services Ltd the go-to choice for homeowners and businesses across Kent.
            </p>
            <div className="space-y-7">
              {reasons.map((reason) => (
                <div key={reason.title} className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#EBF4FF] rounded-xl flex-shrink-0">
                    <i className={`${reason.icon} text-[#1E88E5] text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-700 text-[#0F2040] text-sm mb-1" style={{ fontWeight: 700 }}>
                      {reason.title}
                    </h3>
                    <p className="font-body text-sm text-gray-600 leading-relaxed">{reason.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#quote-form"
                className="flex items-center gap-2 bg-[#1E88E5] hover:bg-[#1565C0] text-white font-heading font-semibold text-sm px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                Get a Free Quote
              </a>
              <a
                href="tel:02084322244"
                className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-[#1A3A6B] font-heading font-semibold text-sm px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                Call 0208 43 222 44
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
